<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/suppliers')" style="cursor: pointer">proveedores</li>
        <li class="breadcrumb-item active" aria-current="page">{{ name }}</li>
      </ol>
    </nav>
    <!-- PAGINA PROVEEDORES -->
    <div class="container-fluid">

      <!-- NEW HEADER -->
      <div class="vx-row mb-base same-h">
        <!-- mensaje de baneo -->
        <div class="vx-col w-full">
          <SupplierRestrictedData v-if="isMounted" :source="supplier" />
        </div>
        <!-- INFO -->
        <div class="vx-col sm:w-full md:w-1/2 lg:w-4/12 mb-base">
          <vx-card>
            <div class="con-example-images">
              <img v-if="logo_url !== null" :src="logo_url" alt="Logo">
            </div>
            <div class="mt-2 profile-data">
              <h4>{{ name }}</h4>
              <h6>{{ email }}</h6>
              <h6>SID: <strong>{{ supplier_id }}</strong> | UID: <strong>{{ user_id }}</strong></h6>
              <h6 class="bold">{{ type == 'PM' ? 'Persona Moral' : 'Persona Física' }}</h6>
              <h6>Última actualización: <br><strong>{{ update_profile_info.last_verified_date_log !== null ?
                logDateFormat(update_profile_info.last_verified_date_log.date) : '--' }}</strong></h6>
              <stp-button :variant="'supplier'" :id="supplier_id" />
            </div>
          </vx-card>
        </div>
        <!-- DETALLE -->
        <div class="vx-col sm:w-full md:w-1/2 lg:w-8/12 mb-base">
          <vx-card class="p-2">
            <div class="vx-row">
              <!-- ESTADO DEL PERFIL -->
              <div class="vx-col sm:w-full md:w-1/2 border-rg">
                <div class="mb-4 ">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="done"></vs-icon>
                    </span>
                    Estatus del proveedor
                  </h6>
                  <vs-chip v-if="verifiedDate == null && verificationRequestDate == null" transparent color="primary">
                    <span class="bold text-xs">Nuevo solicitante</span>
                  </vs-chip>
                  <vs-chip v-if="verifiedDate == null && verificationRequestDate != null" transparent color="warning">
                    <span class="bold text-xs">En verificación</span>
                  </vs-chip>
                  <vs-chip v-if="verifiedDate != null" transparent color="success">
                    <span class="bold text-xs">Verificado</span>
                  </vs-chip>
                  <br>
                </div>
                <div class="mb-4">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="perm_identity"></vs-icon>
                    </span>
                    Verificación de identidad
                  </h6>
                  <user-identity-verification :user-id="user_id" />
                </div>
                <div class="mb-base">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="gavel"></vs-icon>
                    </span>
                    Perfil Legal
                  </h6>
                  <h6>Estado: <br><strong>{{ getLegalProfileStatus(legalProfile) }}</strong></h6>
                  <h6>Última Actualización: <br><strong>{{ legalProfile != null ? logDateFormat(legalProfile.updated_at)
                    : "No se ha verificado el perfil legal" }}</strong></h6>
                </div>
              </div>

              <!-- HERRAMIENTAS GENERAL -->
              <div class="vx-col sm:w-full md:w-1/2">
                <!-- HERRAMIENTAS DE PERFIL -->
                <div v-if="verifiedDate == null" class="mb-base">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="manage_accounts"></vs-icon>
                    </span>
                    Herramientas de perfil
                  </h6>
                  <div class="vx-row">
                    <div v-if="verifiedDate == null" class="vx-col w-1/2 mb-1">
                      <vx-tooltip title="Verificar proveedor" color="primary" style="cursor:pointer" position="top"
                        text="Verifica el perfil del proveedor después de revisar su onboarding, actualiza su fecha de verificación.">
                        <vs-button size="small" color="warning" type="filled" class="mt-2 w-full"
                          @click="requestOnboardingVerification()">Verificar</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="verifiedDate == null" class="vx-col w-1/2 mb-1">
                      <vx-tooltip title="Rechazar proveedor" color="primary" style="cursor:pointer" position="top"
                        text="Rechaza al perfil del proveedor, deshabilita su cuenta por el tiempo que se indique.">
                        <vs-button size="small" color="danger" type="border" class="mt-2 w-full"
                          @click="showModal('rechazar')">Rechazar</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="verifiedDate == null && verificationRequestDate != null" class="vx-col w-1/2">
                      <vx-tooltip title="Regresar perfil" color="dark" style="cursor:pointer" position="top"
                        text="Regresa el perfil al proveedor para que sea completado.">
                        <vs-button size="small" color="dark" type="border" class="mt-2 w-full"
                          @click="requestOnboardingReset()">Regresar a perfil</vs-button>
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
                <!-- HERRAMIENTAS DE expediente -->
                <div v-if="verifiedDate != null && !update_profile_info.update_profile_requirement" class="mb-base">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="source"></vs-icon>
                    </span>
                    Herramientas de expediente
                  </h6>
                  <div class="vx-row">
                    <div v-if="verifiedDate != null && !update_profile_info.update_profile_requirement"
                      class="vx-col w-1/2">
                      <vx-tooltip title="Actualizar expediente" color="primary" style="cursor:pointer" position="top"
                        text="Solicita la actualización de expediente de proveedor.">
                        <vs-button size="small" color="warning" type="filled" class="mt-2 w-full"
                          @click="requestUpdateProfile()">Actualizar Expediente</vs-button>
                      </vx-tooltip>
                    </div>
                    <div
                      v-if="update_profile_info.update_profile_requirement && update_profile_info.update_profile_completed_for_review_date !== null"
                      class="vx-col w-1/2">
                      <vx-tooltip title="Verificar expediente" color="primary" style="cursor:pointer" position="top"
                        text="Verifica la actualización del expediente del proveedor.">
                        <vs-button size="small" color="success" type="filled" class="mt-2 w-full"
                          @click="requestUpdateProfileVerification()">Verificar Expediente</vs-button>
                      </vx-tooltip>
                    </div>
                    <div
                      v-if="update_profile_info.update_profile_requirement && update_profile_info.update_profile_completed_for_review_date !== null"
                      class="vx-col w-1/2">
                      <vx-tooltip title="Rechazar expediente" color="primary" style="cursor:pointer" position="top"
                        text="Rechaza la actualización del expediente del proveedor.">
                        <vs-button size="small" color="danger" type="border" class="mt-2 w-full"
                          @click="isPopupActiveUpdate = true">Rechazar Expediente</vs-button>
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
                <!-- HERRAMIENTAS -->
                <div class="mb-base">
                  <h6 class="bold">
                    <span>
                      <vs-icon icon="build"></vs-icon>
                    </span>
                    Herramientas
                  </h6>
                  <div class="vx-row">
                    <div class="vx-col w-1/2">
                      <vx-tooltip title="Solicitud de crédito" color="primary" style="cursor:pointer" position="top"
                        text="Crea una pre-solicitud de crédito de capital de trabajo.">
                        <vs-button color="dark" size="small" class="mt-2 w-full"
                          @click="isPopUpActiveLoanRequest = true">Crear pre-solicitud</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="verifiedDate != null && stpData == null" class="vx-col w-1/2">
                      <vx-tooltip title="Crear cuenta STP" color="primary" style="cursor:pointer" position="top"
                        text="Sí el proveedor está verificado, crea una cuenta STP para este proveedor.">
                        <vs-button size="small" color="primary" type="border" class="mt-2 w-full"
                          @click="createSupplierSTPAccount()">Generar cuenta STP</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="verifiedDate == null" class="vx-col w-1/2">
                      <vx-tooltip title="Enviar correo" color="primary" style="cursor:pointer" position="top"
                        text="Enviar correo al proveedor con notas sobre su perfil a verificar.">
                        <vs-button size="small" color="primary" type="filled" class="mt-2 w-full"
                          @click="isPopupActive = true">Enviar correo</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="hasRole('supplier_operator')" class="vx-col w-1/2">
                      <vx-tooltip title="Restringir proveedor" color="danger" style="cursor:pointer" position="top"
                        text="Restringir la cuenta del proveedor y limita sus acciones para con RG">
                        <vs-button size="small" color="danger" type="filled" class="mt-2 w-full"
                          @click="isBlackListFormActive = true">Restringir proveedor</vs-button>
                      </vx-tooltip>
                    </div>
                    <div v-if="verifiedDate == null" class="vx-col w-1/2">
                      <vx-tooltip title="Correos enviados" color="primary" style="cursor:pointer" position="top"
                        text="Muestra los correos enviados al proveedor en los últimos 45 días.">
                        <user-emails-sent-list v-if="email !== null && email !== ''" class="mt-2 w-full"
                          :userEmail="email" :btnConfig="btnConfig" />
                      </vx-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <!-- ONBOARDING -->
        <div class="vx-col sm:w-full md:w-1/2 lg:w-7/12">
          <vx-card class="p-2">
            <h6 class="bold mb-3">
              <span>
                <vs-icon icon="published_with_changes"></vs-icon>
              </span>
              Detalle del onboarding
              <vs-button @click.stop="getOnboardingCheck()" color="primary" size="small" class="ml-base p-2">
                <span>
                  <vs-icon icon="restore"></vs-icon>
                </span>
              </vs-button>
            </h6>
            <div class="demo-alignment custom">
              <div v-for="(item, index) in onboardingSteps">
                <div class="onbaoring-step">
                  <vs-chip class="bold" :color="stepIsCompleted(item.key) ? 'success' : 'warning'">
                    {{ item.name }}
                  </vs-chip>
                  <p class="pill-desc mt-1">{{ stepIsCompleted(item.key) ? 'Completado' : 'En revisión' }}</p>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
        <!-- ONBOARDING -->
        <div class="vx-col sm:w-full md:w-1/2 lg:w-5/12">
          <vx-card>
            <div>
              <h6 class="bold">Eventos</h6>
            </div>
            <vx-card no-shadow class="events-list">
              <vx-timeline :data="supplierEvents"></vx-timeline>
            </vx-card>
          </vx-card>
        </div>
      </div>

      <!-- BITÁCORA -->
      <div class="row mt-0">
        <div class="col-md-12">
          <vs-collapse type="border">
            <vs-collapse-item>
              <div slot="header">
                Bitácora
              </div>
              <div class="row mt-0">
                <div class="col-md-12">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="comentario" @keyup.enter="comentar()"
                      placeholder="Escribe un comentario...">

                    <div class="input-group-prepend">
                      <button class="btn btn-primary btn-raised" :disabled="comentario == ''" type="button"
                        @click="comentar()">
                        <em class="material-icons">send</em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-0">
                <div class="col-md-12">
                  <vs-table ref="table" stripe pagination max-items="5" :data="messages"
                    noDataText="No hay datos disponibles">
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                    <template slot="thead">
                      <vs-th v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null">{{
                        col.title }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].created_at">
                          <vs-chip transparent color="primary">
                            <span class="text-xs"> {{ tr.created_at | human_date }} </span>
                          </vs-chip>
                        </vs-td>
                        <vs-td :data="data[indextr].id">
                          <vs-chip transparent color="warning">
                            <span class="bold text-xs"> {{ tr.email }} </span>
                          </vs-chip><br><br>
                          {{ tr.note }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
      <!-- TABS -->
      <div class="row mb-4">
        <div class="col-md-12">
          <nav class="nav nav-pills nav-fill">
            <button class="btn btn-light nav-item nav-link active" @click="option = 'supplier'" style="cursor:pointer">
              Perfil Proveedor
            </button>
            <!--button class="btn btn-light nav-item nav-link active" @click="option = 'person'" style="cursor:pointer">Persona</button-->
            <!--button class="btn btn-light nav-item nav-link active" @click="option = 'contacts'" style="cursor:pointer">Contacto</button-->
            <button class="btn btn-light nav-item nav-link active" @click="option = 'parameter'" style="cursor:pointer">
              Parámetros
            </button>
            <!--button class="btn btn-light nav-item nav-link active" @click="option = 'bank'" style="cursor:pointer">Banco</button-->
            <button class="btn btn-light nav-item nav-link active" @click="option = 'agents'" style="cursor:pointer">
              Agentes
            </button>
            <button class="btn btn-light nav-item nav-link active" @click="option = 'invoices'" style="cursor:pointer">
              Facturas
            </button>
            <!-- <button class="btn btn-light nav-item nav-link active" @click="option = 'products'" style="cursor:pointer">
              Productos
            </button> -->
            <button class="btn btn-light nav-item nav-link active" @click="option = 'applicants'"
              style="cursor:pointer">Solicitantes
            </button>
            <button class="btn btn-light nav-item nav-link active" @click="option = 'supplier-scoring'"
              style="cursor:pointer">Evaluación
            </button>
            <button class="btn btn-light nav-item nav-link active" @click="option = 'score-model'"
              style="cursor:pointer">Modelo Calif.
            </button>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <!-- <div class="alert alert-info" role="alert">
              Información faltante:
              <ul>
                  <li v-if="missing.enterprise != ''"><strong>Empresa:</strong> {{ missing.enterprise }}</li>
                  <li v-if="missing.acredit != ''"><strong>Acreditación:</strong> {{ missing.acredit }}</li>
                  <li v-if="missing.contact != ''"><strong>Persona:</strong> {{ missing.contact }}</li>
                  <li v-if="missing.residence != ''"><strong>Domicilio:</strong> {{ missing.residence }}</li>
                  <li v-if="missing.bank != ''"><strong>Banco:</strong> {{ missing.bank }}</li>
              </ul>
          </div> -->
        </div>
      </div>
      <div class="row" v-if="option === 'supplier'">
        <div class="col-md-12">
          <!-- DOCUMENTOS -->
          <div class="row mt-0 mb-2">
            <div class="col-md-12">
              <vx-card>
                <vs-collapse type="border">
                  <vs-collapse-item>
                    <div slot="header">
                      Documentos
                    </div>
                    <div class="vx-row">
                      <documents-section class="w-full" ref="edit_profile" :supplier_id="supplier_id" :user_id="user_id"
                        :supplier_status="status" :update_profile_info="update_profile_info"></documents-section>
                    </div>
                  </vs-collapse-item>
                </vs-collapse>
              </vx-card>
            </div>
          </div>
          <edit-profile ref="edit_profile" :supplier_id="supplier_id" :user_id="user_id" :supplier_status="status"
            :update_profile_info="update_profile_info"></edit-profile>
        </div>
      </div>
      <div class="row" v-if="option === 'person'">
        <div class="col-md-12">
          <supplier-personal :id_supplier="supplier_id" :usuario="user_id"></supplier-personal>
        </div>
      </div>
      <div class="row" v-if="option === 'contacts'">
        <div class="col-md-12">
          <supplier-contacts :id_supplier="supplier_id" :usuario="user_id"></supplier-contacts>
        </div>
      </div>
      <div class="row" v-if="option === 'parameter'">
        <div class="col-md-12">
          <supplier-parameters :id_supplier="supplier_id" :usuario="user_id"></supplier-parameters>
        </div>
      </div>
      <div class="row" v-if="option === 'bank'">
        <div class="col-md-12">
          <supplier-bank :id_supplier="supplier_id" :usuario="user_id" :user_roles="user_roles"></supplier-bank>
        </div>
      </div>
      <div class="row" v-if="option === 'agents'">
        <div class="col-md-12">
          <supplier-agents-admin :id_supplier="supplier_id" :usuario="user_id"></supplier-agents-admin>
        </div>
      </div>
      <div class="row" v-if="option === 'invoices'">
        <div class="col-md-12">
          <withdrawals-supplier-module :filters="{ 'suppliers.id': supplier_id }"
            variant='supplierModule'></withdrawals-supplier-module>
        </div>
      </div>
      <div class="row" v-if="option === 'applicants'">
        <div class="col-md-12">
          <applicants-page :SupplierId="supplier_id" variant='supplierModule'></applicants-page>
        </div>
      </div>
      <div class="row" v-if="option === 'products'">
        <div class="col-md-12">
          <supplier-products-page :SupplierId="supplier_id" variant='supplierModule'></supplier-products-page>
        </div>
      </div>
      <div class="row" v-if="option === 'supplier-scoring'">
        <div class="col-md-12">
          <supplier-scoring :SupplierId="supplier_id" variant='supplierModule'></supplier-scoring>
        </div>
      </div>
      <div class="row" v-if="option === 'score-model'">
        <div class="col-md-12">
          <profile-verification-resume :supplierId="parseInt(supplier_id)" />
        </div>
      </div>
      <br>

      <!-- MODAL CONFIRMAR VERIFICACION PROVEEDOR -->
      <div class="modal fade" ref="verificar" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" v-on:click="hideModal('verificar')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-2 text-center"></div>
                <div class="col-md-8 text-center" style="margin-bottom: 15px;">
                  <h5 style="margin-top: -35px;margin-bottom: 20px;">¿Deseas verificar a {{ name }}?</h5>
                  <button class="btn btn-primary btn-raised" type="button" @click="send(true)"
                    style="margin-right: 25px;">Confirmar
                  </button>
                  <button class="btn btn-danger btn-raised" type="button" data-dismiss="modal">Cancelar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MODAL COMENTARIOS PROVEEDOR -->
      <!-- <div class="modal fade" ref="comentar" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-md" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" v-on:click="hideModal('comentar')">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-md-2 text-center"></div>
                          <div class="col-md-8 text-center" style="margin-bottom: 15px;">
                              <h5 for="tradename" style="margin-top: -35px;margin-bottom: 20px;">Enviar correo a {{name}}:</h5>
                              <textarea type="text" class="form-control" v-model="reasons" :placeholder="'Mensaje...'"></textarea>
                              <button class="btn btn-primary btn-raised" type="button" style="margin-right: 25px;margin-top:10px" @click="send(false)" data-dismiss="modal">Enviar</button>
                              <button class="btn btn-danger btn-raised" type="button" style="margin-top:10px" data-dismiss="modal">Cancelar</button>
                          </div>
                      </div>
                      <div class="modal-footer">
                          <small>Al enviar el correo, el estatus de {{name}} pasará a No Verificado para que pueda actualizar su información de acuerdo con los comentarios enviados.</small>
                      </div>
                  </div>
              </div>
          </div>
      </div> -->

      <!-- POPUP RECHAZO DE VERIFICACIÓN -->
      <vs-popup :active.sync="isPopupActive" :title="`Enviar correo a ${name}`">
        <div class="vx-row">
          <div class="vx-col w-full">
            <small>Recuerda agregar <strong>punto y coma (;)</strong> al final de cada oración para agregar un salto de
              línea.</small><br>
            <small>Al enviar el correo, el estatus de {{ name }} pasará a No Verificado para que pueda actualizar su
              información de acuerdo con los comentarios enviados.</small>
          </div>
          <div class="vx-col w-full mt-4 mb-4">
            <vx-textarea v-model="reasons" height="300px" />
          </div>
          <div class="flex flex-wrap-reverse items-center flex-grow" style="justify-content: space-evenly !important;">
            <vs-button @click="send(false)" color="primary" type="filled">Enviar</vs-button>
            <vs-button @click="isPopupActive = false" color="danger" type="filled">Cancelar</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- POPUP RESTRICCION DEL PROVEEDOR -->
      <vs-popup :active.sync="isBlackListFormActive" :title="`Restringir a ${name}`">
        <div class="vx-row">
          <div class="vx-col w-full">
            Selecciona el nivel de restricción que deseas aplicar al proveedor <strong>{{ supplier_id }} | {{ name
            }}</strong>.
          </div>
          <div class="vx-col w-full mt-4 mb-4">
            <vs-select v-model="blackListLevel" class="w-full" label="Nivel de restricción"
              placeholder="Selecciona un nivel de restricción" autocomplete="off">
              <vs-select-item v-for="item in blackListLevels" :key="item.value" :value="item.value" :text="item.text" />
            </vs-select>
          </div>
          <div v-if="blackListLevel != null" class="vx-col w-full mb-4">
            <h6 color="primary bold">Bloqueos de plataforma:</h6>
            <ul v-if="blackListLevel == 'medium'">
              <li>
                * No se podrá aprobar un nuevo crédito mientras ya tenga uno o más en estatus 4, 5, 6 o 7.
              </li>
              <li>
                * No se podrá asignar al Proveedor a algún proyecto.
              </li>
            </ul>
            <ul v-else-if="blackListLevel == 'high'">
              <li>
                * Bloqueos de Nivel Medio, más...
              </li>
              <li>
                * El Solicitante no podrá crear solicitudes relacionadas con el Proveedor.
              </li>
              <li>
                * El potencial Solicitante no podrá hacer uso del código o QR del Proveedor en el proceso de Onboarding.
              </li>
            </ul>
            <ul v-else-if="blackListLevel == 'banned'">
              <li>
                * Bloqueos de Nivel Medio y Alto, más...
              </li>
              <li>
                * Invalidación de código QR.
              </li>
              <li>
                * Cancelación de cuenta de proveedor.
              </li>
            </ul>
            <ul v-else>
              <li>
                * No se aplicará ninguna restricción al proveedor.
              </li>
            </ul>
          </div>
          <div class="vx-col w-full mt-4 mb-4">
            <vx-textarea v-model="reasons" height="300px" label="¿Por qué se restringe al proveedor?" />
          </div>
          <div class="flex flex-wrap-reverse items-center flex-grow" style="justify-content: space-evenly !important;">
            <vs-button :disabled="reasons == '' || blackListLevel == 0" @click="requestSupplierBlackListed()"
              color="success" type="filled">Aceptar</vs-button>
            <vs-button @click="isBlackListFormActive = false" color="black" type="filled">Cancelar</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- POPUP RECHAZO DE ACTUALIZACIÓN -->
      <vs-popup :active.sync="isPopupActiveUpdate" :title="`Rechazar expediente`">
        <div class="vx-row">
          <div class="vx-col w-full">
            <small>Recuerda agregar <strong>punto y coma (;)</strong> al final de cada oración para agregar un salto de
              línea.</small><br>
            <small>Escribe las razones por las cuales se está rechazando la <strong>actualización de expediente</strong>
              del
              proveedor <strong>{{ supplier_id }} | {{ name }}</strong>.</small>
          </div>
          <div class="vx-col w-full mt-4 mb-4">
            <vx-textarea v-model="reasons" height="300px" />
          </div>
          <div class="flex flex-wrap-reverse items-center flex-grow" style="justify-content: space-evenly !important;">
            <vs-button @click="requestRejectUpdateProfile()" color="primary" type="filled">Enviar</vs-button>
            <vs-button @click="isPopupActiveUpdate = false, reasons = ''" color="danger"
              type="filled">Cancelar</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- POPUP SOLICITAR CRÉDITO -->
      <vs-popup :active.sync="isPopUpActiveLoanRequest" :title="`Solicitar crédito a proveedor`">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p>Estás por crear una solicitud de crédito para este proveedor, antes dinos el monto del crédito:</p>
            <vs-input ref="currency" class="w-full" label="Monto del crédito" type="text" v-model.lazy="aliasCurrency"
              v-money="money" name="total_cost" :min="0" autocomplete="off" icon-pack="feather" icon="icon-dollar-sign"
              description-text="Monto de crédito para proveedor" placeholder="Requerido" />
          </div>
          <div class="flex flex-grow flex-wrap-reverse items-center justify-content-end mt-4 p-2">
            <vs-button @click="isPopUpActiveLoanRequest = false, total_cost = null" color="danger"
              type="line">Cancelar</vs-button>
            <vs-button @click="requestSupplierLoan()" color="dark" type="filled" class="ml-2 float-rigth">Crear
              crédito</vs-button>
          </div>
        </div>
      </vs-popup>

      <!-- MODAL RECHAZAR PROVEEDOR -->
      <div class="modal fade" ref="rechazar" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" v-on:click="hideModal('rechazar')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-2 text-center"></div>
                <div class="col-md-8 text-center" style="margin-bottom: 15px;">
                  <h5 for="tradename" style="margin-top: -35px;margin-bottom: 20px;">¿Estas seguro que deseas rechazar a
                    {{ name }}?</h5>
                  <small>Escribe las razones de su rechazo aquí</small>
                  <textarea type="text" class="form-control" v-model="reasons"></textarea>
                  <br>
                  <small>Indica los meses que debe esperar para volver a intentarlo</small>
                  <input type="number" class="form-control" v-model="meses" min="0" style="text-align: right;" />
                  <br>
                  <button class="btn btn-primary btn-raised" type="button" style="margin-right: 25px;margin-top:10px"
                    @click="rechazar(false)" data-dismiss="modal">Confirmar
                  </button>
                  <button class="btn btn-danger btn-raised" type="button" style="margin-top:10px" data-dismiss="modal">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-popup title="Actualizar perfil legal del proveedor." :active.sync="showLPModal">
        <div class="con-exemple-prompt">
          <p class="mb-5 bold">Seleccione el estado legal de este proveedor.</p>

          <label for="" class="vs-input--label">¿Tiene coincidencias relevantes en material legal?</label>
          <v-select label="text" name="family_group_id" class="vs-custom w-full mb-5" v-model.lazy="legalProfileValue"
            :options="options" :reduce="text => text.value" :clearable="false" :searchable="false"
            placeholder="Seleccione una opción">
          </v-select>

          <vs-button :disabled="legalProfileValue == null" @click="saveLegalProfile" color="primary"
            class="mr-5 mt-2">Actualizar perfil</vs-button>
          <vs-button @click="showLPModal = false" type="flat" color="primary">Cerrar</vs-button>

        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script lang="js">
import WithdrawalsSupplierModule from "../treasury/withdrawals-supplier-module";
import UserEmailsSentList from "@components/profile_shared/UserEmailsSentList";
let SupplierInfo = require('./SupplierInfo').default;
let SupplierPersonal = require('./SupplierPersonal').default;
let SupplierContacts = require('./SupplierContacts').default;
let SupplierParameters = require('./SupplierParameters').default;
let SupplierBank = require('./SupplierBank').default;
let SupplierAgents = require('./SupplierAgents').default;
let EditProfile = require('./EditProfile').default;
let ApplicantsPage = require('./ApplicantsPage').default;
let SupplierProductsPage = require('./SupplierProductsPage').default;
let SupplierScoring = require('./SupplierScoring').default;

import { mapState } from 'vuex'
import * as moment from 'moment'
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import DuePortfolioSupplierStats from "@components/supplier/DuePortfolioSupplierStats";
import ProfileVerificationResume
  from "@views/admin/RiskModel/Dashboard/RiskModel/SupplierRiskModel/ProfileVerificationResume/ProfileVerificationResume";
import { VMoney } from 'v-money';
import UserIdentityVerification from '@components/profile_shared/UserIdentityVerification';
import DocumentsSection from '@views/admin/suppliers/DocumentsSection';
import StpButton from '@components/stp/StpButton';

const options = [
  { value: true, text: "Si" },
  { value: false, text: "No" },
];

const columns = [
  { title: "", key: "date", sortable: true }
  , { title: "", key: "message", sortable: false }
]

const logo_section_id = 1;

const pfOnboardingSteps = [
  { key: "pf_mex_1_signup", name: "Registro", desc: "" },
  { key: "pf_mex_2_cellphone_checked", name: "Verificación de teléfono", desc: "" },
  { key: "pf_mex_3_name", name: "Información general", desc: "" },
  { key: "pf_mex_4_fiscal_profile", name: "Perfil Fiscal", desc: "" },
  { key: "pf_mex_5_address", name: "Dirección", desc: "" },
  { key: "pf_mex_6_business_checkpoint_1", name: "Checkpoint 1", desc: "" },
  { key: "pf_mex_7_id_verification", name: "Verificación de identidad", desc: "" },
  // { key: "pf_mex_8_credit_history_report", name: "Reporte crediticio", desc: "" }, -- NO SE USA
  { key: "pf_mex_9_social_networks", name: "Redes Sociales", desc: "" },
  { key: "pf_mex_10_coverage", name: "Cobertura", desc: "" },
  { key: "pf_mex_11_main_contacts", name: "Contactos", desc: "" },
  { key: "pf_mex_12_business_checkpoint_2", name: "Checkpoint 2", desc: "" },
  { key: "pf_mex_13_technology_training_certifications", name: "Certificación de tecnologías", desc: "" },
  { key: "pf_mex_16_technology_checkpoint", name: "Documentos", desc: "" },
  { key: "pf_mex_17_record_of_knowledge", name: "Firma de Constancia", desc: "" },
  { key: "pf_mex_18_merchant_contract", name: "Firma contrato CM", desc: "" }
];

const pmOnboardingSteps = [
  { key: "pm_mex_1_signup", name: "Registro", desc: "" },
  { key: "pm_mex_2_cellphone_checked", name: "Verificación de teléfono", desc: "" },
  { key: "pm_mex_3_name", name: "Información general", desc: "" },
  { key: "pm_mex_4_fiscal_profile", name: "Perfil Fiscal", desc: "" },
  // { key: "pm_mex_5_constitution_file", name: "", desc: "" }, -- NO SE USA
  { key: "pm_mex_6_address", name: "Dirección", desc: "" },
  // { key: "pm_mex_7_business_credit_history_report", name: "", desc: "" }, -- no se usa
  { key: "pm_mex_8_business_checkpoint_1", name: "Checkpoint 1", desc: "" },
  { key: "pm_mex_9_id_verification_legal_representative", name: "Verificación de identidad", desc: "" },
  // { key: "pm_mex_10_legal_representative_credit_history_report", name: "", desc: "" }, --  no se usa
  { key: "pm_mex_11_social_networks", name: "Redes Sociales", desc: "" },
  { key: "pm_mex_12_coverage", name: "Cobertura", desc: "" },
  { key: "pm_mex_13_main_contacts", name: "Contactos", desc: "" },
  { key: "pm_mex_14_business_checkpoint_2", name: "Checkpoint 2", desc: "" },
  // { key: "pm_mex_15_technology_training_certifications", name: "", desc: "" }, -- no se usa
  // { key: "pm_mex_16_technology_testimonies", name: "", desc: "" }, -- no se usa
  // { key: "pm_mex_17_technology_questionnaire", name: "", desc: "" }, -- no se usa
  { key: "pm_mex_18_technology_checkpoint", name: "Documentos", desc: "" },
  { key: "pm_mex_19_record_of_knowledge", name: "Firma de Constancia", desc: "" },
  { key: "pm_mex_20_merchant_contract", name: "Firma contrato CM", desc: "" },
];

const blackListLevels = [
  { value: "no_restriction", text: "Sin restricción" },
  { value: "alert", text: "Alerta" },
  { value: "medium", text: "Medio" },
  { value: "high", text: "Alto" },
  { value: "banned", text: "Inhabilitado" },
];

export default {
  name: 'suppliers',
  mixins: [dateHelper, formatHelper],
  filters: {
    human_date(date) {
      return moment(date).lang("es").format("D MMM H:mm");
    }
  },
  directives: { money: VMoney },
  computed: {
    ...mapState("auth", ["user", "geolocation"]),
    photoURL() {
      return this.avatar;
    },
    logo_url() {
      if (this.logo_doc_file_url !== null && this.logo_doc_file_url !== '') {
        return this.ApiDomain + this.logo_doc_file_url;
      }
      return null;
    },
    isMoral() {
      return this.type == 'PM';
    },
    isBackoffice() {
      return process.env.VUE_APP_IS_BACKOFFICE == 'true';
    },
  },
  components: {
    ProfileVerificationResume,
    WithdrawalsSupplierModule,
    'supplier-info': SupplierInfo,
    'supplier-personal': SupplierPersonal,
    'supplier-contacts': SupplierContacts,
    'supplier-parameters': SupplierParameters,
    'supplier-bank': SupplierBank,
    'supplier-agents-admin': SupplierAgents,
    'edit-profile': EditProfile,
    'applicants-page': ApplicantsPage,
    'supplier-products-page': SupplierProductsPage
    , 'supplier-scoring': SupplierScoring,
    DuePortfolioSupplierStats,
    UserEmailsSentList,
    UserIdentityVerification,
    DocumentsSection,
    StpButton
  },
  async mounted() {
    this.isMounted = false;
    window.document.title = `SID: ${this.$route.params.id}`;
    await this.traerDatos();
    this.getOnboardingCheck();
    this.user_roles = this.user.user_roles;
    this.isMounted = true;
  },
  data() {
    return {
      supplier: null,
      options: options,
      showLPModal: false,
      legalProfileValue: null,
      option: 'supplier',
      reasons: '',
      name: '',
      email: '',
      type: '',
      user_id: 0,
      status: 0,
      missing: {
        enterprise: '',
        acredit: '',
        contact: '',
        residence: '',
        bank: ''
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      update_profile_info: null,
      messages: [],
      comentario: '',
      ver: false,
      meses: 0,
      supplier_id: this.$route.params.id,
      user_roles: [],
      isPopupActive: false,
      isBlackListFormActive: false,
      blackListLevels: blackListLevels,
      blackListLevel: 0,
      columns: columns
      , isPopupActiveUpdate: false
      , logo_section_id: logo_section_id
      , docInfo: null
      , logo_doc_file_url: ''
      , avatar: require('@assets/images/supplier_avatar.png')
      , btnConfig: {
        type: "filled",
        color: "primary",
        size: "small"
      }
      , isPopUpActiveLoanRequest: false
      , total_cost: null
      , aliasCurrency: null
      , useAliasCurrency: false
      , watchAlias: true
      , supplierOnboarding: null
      , verifiedDate: null
      , rejectedDate: null
      , verificationRequestDate: null
      , legalProfile: null
      , stpData: null
      , onboardingSteps: []
      , onboardingCheck: []
      , supplierBlackListedLevel: 0
      , supplierBlackListedReasons: null
      , supplierBlackListedTimestamp: null
      , isMounted: false
      , supplierEvents: []
    }
  },
  watch: {
    aliasCurrency: function (nval, oldval) {
      if (this.watchAlias) {
        this.total_cost = this.unCurrencyFormat(nval);
      }
    },
  },
  methods: {
    requestSupplierLoan() {
      if (this.total_cost !== null
        && this.total_cost != 0
        && this.total_cost != 0.0
        && this.total_cost != "0"
      ) {
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Solicitar crédito",
          text: `¿Estás seguro de solicitar un crédito para el proveedor ${this.supplier_id} | ${this.name} por la cantidad ${this.costFormat(this.total_cost)}?`,
          acceptText: "Solicitar crédito",
          cancelText: "Cancelar",
          accept: this.doCreateRequestLoan,
        });
      } else {
        this.missingFieldsNotif();
      }
    },

    async doCreateRequestLoan() {
      try {
        this.showLoading(true);
        const payload = {
          supplier_id: this.supplier_id
          , total_cost: this.total_cost
          , geolocation: `Lat: ${this.geolocation.latitude}, Long: ${this.geolocation.longitude}`
        }
        const res = await axios.post(`/api/post/suppliers/create/pre-request`, payload);
        if (res.data.success) {
          this.total_cost = 0;
          this.isPopUpActiveLoanRequest = false;
          this.saveSuccessNotif(null, `Se ha generado con éxtio la solicitud ${res.data.id}`);
        }
        this.showLoading(false);
      } catch (error) {
        this.showLoading(false);
        console.log(error);
      }
    },
    unCurrencyFormat(value) {
      if (!value) return 0;
      let str = value.toString();
      let val = value.replace(",", "");
      val = val.replace(",", "");
      val = val.replace(",", "");
      val = val.replace(",", "");
      val = val.replace(",", "");
      val = val.replace(",", "");
      return parseFloat(val.toString());
    },

    async send(verified) {
      this.showLoading(true);
      let response;
      // Vue.toasted.show('Enviando...', { position: 'bottom-center', closeOnSwipe: false });
      var data = {
        verified: verified,
        supplier: this.$route.params.id,
        reasons: this.reasons
      };
      try {
        response = await axios.post('/api/supplier/verify/' + this.$route.params.id, data);

        if (response.status === 200 && response.statusText === "OK") {
          this.isPopupActive = false;
          this.reasons = "";
          this.traerDatos();
          this.createSupplierSTPAccount();
          Vue.toasted.clear();
          Vue.toasted.show(this.name + ' ha sido notificado!', {
            position: 'bottom-center',
            type: 'success',
            closeOnSwipe: false,
            duration: 5000
          });
        }

      } catch (e) {
        Vue.toasted.clear();
        this.showLoading(false);
        this.errorNotif("No se ha verificado al proveedor.", e.response.data.errors);
      }
      this.hideModal('verificar');
      this.showLoading(false);
    },
    comentar() {
      Vue.toasted.show('Agregando...', { position: 'bottom-center', closeOnSwipe: false });
      axios.post('/api/supplier/note/' + this.$route.params.id, {
        reasons: this.comentario
      }).then(response => {
        this.comentario = ""
        this.traerDatos()
        Vue.toasted.clear()
        Vue.toasted.show('¡Comentario agregado!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 5000
        })
      })
    },
    async traerDatos() {
      const response = await axios.get('/api/supplier/detail/' + this.$route.params.id);
      this.supplier = response.data;
      this.name = response.data.tradename;
      this.status = response.data.status;
      this.email = response.data.email;
      this.user_id = response.data.user_id;
      this.type = response.data.type;
      this.messages = response.data.messages;
      this.logo_doc_file_url = response.data.logo_doc_file_url;
      this.update_profile_info = response.data.update_profile_info;
      this.supplierOnboarding = response.data.supplier_onboarding
      this.verifiedDate = response.data.verified_date
      this.rejectedDate = response.data.rejected_date
      this.verificationRequestDate = response.data.verification_request_date
      this.legalProfile = response.data.legal_profile
      this.getSupplierSTPAccount();
      this.getSupplierEventsList();
    },
    rechazar() {
      if (this.meses == 0) {
        Vue.toasted.show('¡Debes de indicar al menos los meses que debe esperar ' + this.name + ' para volver a intentarlo!', {
          position: 'top-center',
          type: 'error',
          closeOnSwipe: false,
          duration: 5000
        })
      } else {
        Vue.toasted.show('Rechazando...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post('/api/supplier/reject/' + this.$route.params.id, {
          reasons: this.reasons,
          meses: this.meses
        }).then(response => {
          this.reasons = ""
          this.traerDatos()
          Vue.toasted.clear()
          Vue.toasted.show(this.name + ' ha sido rechazado y notificado!', {
            position: 'bottom-center',
            type: 'success',
            closeOnSwipe: false,
            duration: 5000
          })
        }).catch(error => {
          Vue.toasted.clear()
          Vue.toasted.show('¡ERROR! No se pudo rechazar a ' + this.name, {
            position: 'bottom-center',
            type: 'error',
            closeOnSwipe: true,
            duration: 10000
          })
        });
      }
    },
    showModal(destino) {
      if (destino == "verificar") {
        let element = this.$refs.verificar;
        $(element).modal('show');
      }
      if (destino == "comentar") {
        let element = this.$refs.comentar;
        $(element).modal('show');
      }
      if (destino == "rechazar") {
        let element = this.$refs.rechazar;
        $(element).modal('show');
      }
    },
    hideModal(destino) {
      if (destino == "verificar") {
        let element = this.$refs.verificar;
        $(element).modal('hide');
      }
      if (destino == "comentar") {
        let element = this.$refs.comentar;
        $(element).modal('hide');
      }
      if (destino == "rechazar") {
        let element = this.$refs.rechazar;
        $(element).modal('hide');
      }
    },

    requestSupplierBlackListed() {
      this.$vs.dialog({
        color: "warning",
        type: "confirm",
        title: "Solicitud de restricción de proveedor",
        text: `¿Estás seguro de restringir el perfil del proveedor ${this.supplier_id} | ${this.name}? Se limitarán sus herramientas dentro de la plataforma de Proveedor.`,
        acceptText: "Solicitar restricción",
        cancelText: "Cancelar",
        accept: this.doRequestSupplierBlackListed,
      });
    },

    /**
     * Marca al proveedor en lista negra
     */
    async doRequestSupplierBlackListed() {
      try {
        this.showLoading(true);
        await axios.post(`/api/supplier/post/black-listed`, {
          supplier_id: this.supplier_id,
          level: this.blackListLevel,
          reasons: this.reasons
        });
        await this.traerDatos();
        this.reasons = "";
        this.isBlackListFormActive = false;
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (error) {
        this.showLoading(false);
        this.failedOperationNotif();
        console.log(error);
      }
    },

    // #region Onboarding

    requestOnboardingVerification() {
      this.$vs.dialog({
        color: "warning",
        type: "confirm",
        title: "Solicitar verificación con onboarding",
        text: `¿Estás seguro de verificar el perfil del proveedor ${this.supplier_id} | ${this.name}? Se verificará la información de su onboarding y será verificado en caso de estar completo.`,
        acceptText: "Solicitar verificación",
        cancelText: "Cancelar",
        accept: this.doRequestOnboardingVerification,
      });
    },
    async doRequestOnboardingVerification() {
      try {
        this.showLoading(true);
        const res = await axios.post(`/api/supplier-onboarding/post/profile-verification`, {
          supplier_id: this.supplier_id,
          is_verification: true
        });

        if (res.data == "success") {
          this.saveSuccessNotif(null, "El proveedor ha sido verificado.");
          this.traerDatos();
          this.createSupplierSTPAccount();
        } else {
          this.missingFieldsNotif(null, res.data);
        }

        this.showLoading(false);

      } catch (error) {
        this.showLoading(false);
        console.log(error);
      }
    },
    requestOnboardingReset() {
      this.$vs.dialog({
        color: "warning",
        type: "confirm",
        title: "Regresar perfil a proveedor no verificado",
        text: `¿Estás seguro de regresar el perfil del proveedor ${this.supplier_id} | ${this.name}? Se calculará su onboarding step y se marcará su fecha de revisión como nula.`,
        acceptText: "Regresar perfil",
        cancelText: "Cancelar",
        accept: this.doRequestOnboardingReset,
      });
    },
    async doRequestOnboardingReset() {
      try {
        this.showLoading(true);
        const res = await axios.post(`/api/supplier-onboarding/post/profile-return`, {
          supplier_id: this.supplier_id
        });

        if (res.data == "success") {
          this.saveSuccessNotif(null, "El proveedor ha sido verificado.");
          await this.postSupplierProfileAsReviewed();
          this.traerDatos();
          await this.getOnboardingCheck();
        } else {
          this.missingFieldsNotif(null, res.data);
        }

        this.showLoading(false);

      } catch (error) {
        this.showLoading(false);
        console.log(error);
      }
    },
    async getOnboardingCheck() {
      try {
        this.showLoading(true);
        const res = await axios.get(`/api/supplier-onboarding/get/${this.supplier_id}/onboarding-check`);
        this.onboardingCheck = res.data;
        if (this.isMoral) {
          this.onboardingSteps = pmOnboardingSteps;
        } else {
          this.onboardingSteps = pfOnboardingSteps
        }
        this.showLoading(false);
      } catch (error) {
        this.showLoading(false);
        console.log(error);
      }
    },
    stepIsCompleted(step) {
      let completed = false;
      if (this.onboardingCheck != null) {
        completed = this.onboardingCheck[step];
      }
      return completed;
    },
    // #endregion
    // #region STP Account
    async createSupplierSTPAccount() {
      this.showLoading(true);
      try {
        let response = await axios.post(`/api/stp/v1/account/supplierId/${this.supplier_id}`);
        if (response.data != null) {
          this.saveSuccessNotif("Cuenta STP creada", "Se ha creado de manera correcta la cuenta STP para este proveedor.")
        }
      } catch (e) {
        this.failedOperationNotif("Algo salió mal", "No se ha podido crear la cuenta STP para este proveedor.")
        console.error("FALLÓ LA CREACIÓN DE LA CUENTA STP");
      }
      this.showLoading(false);
    },
    async getSupplierSTPAccount() {
      this.showLoading(true);
      try {
        let response = await axios.get(`/api/stp/v1/account/supplierId/${this.supplier_id}`);
        if (response.data != null) {
          this.stpData = response.data;
        }
      } catch (e) {
        // this.failedOperationNotif("Algo salió mal", "No se ha podido crear la cuenta STP para este proveedor.")
        console.error("NO HAY INFORMACIÓN DE LA CUENTA STP");
      }
      this.showLoading(false);
    },
    // #endregion

    // #region Actualizar Expediente
    async requestUpdateProfileVerification() {
      const validate = await this.$refs.edit_profile.checkForValidVerification();
      if (validate) {
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Verificar actualización de expediente",
          text: `¿Estás seguro de verificar la actualización de expediente del proveedor ${this.supplier_id} | ${this.name}?`,
          acceptText: "Verificar actualización",
          cancelText: "Cancelar",
          accept: this.doUpdateProfileVerification,
        });
      }
    },

    async doUpdateProfileVerification() {
      this.showLoading(true);
      try {
        const res = await axios.post(`/api/v1/supplier/profile/update/verify/${this.supplier_id}`);
        if (res.data == "success") {
          this.saveSuccessNotif("Actualización de expediente verificada", "El perfil ha sido verificado de manera exitosa.", 8000);
          this.traerDatos();
        }
      } catch (e) {
        this.warn(e);
      }
      this.showLoading(false);
    },

    requestRejectUpdateProfile() {
      if (this.reasons !== "") {
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Rechazar actualización de expediente",
          text: `¿Estás seguro de rechazar la actualización de expediente del proveedor ${this.supplier_id} | ${this.name}? Su plazo limite de actualización también cambiará.`,
          acceptText: "Rechazar actualización",
          cancelText: "Cancelar",
          accept: this.doRejectUpdateProfile,
        });
      } else {
        this.errorNotif("Sin razones.", "Es necesario darle una razón de rechazo al proveedor.");
      }
    },
    async doRejectUpdateProfile() {
      this.showLoading(true);
      try {
        const payload = {
          supplier_id: this.supplier_id
          , reasons: this.reasons
        };
        const res = await axios.post(`/api/v1/supplier/profile/update/reject`, payload);

        if (res.data == "success") {
          this.saveSuccessNotif("Actualización de expediente rechazado", "El perfil ha sido rechazado de manera exitosa.", 8000);
          this.traerDatos();
          this.reasons = "";
        }
      } catch (e) {
        this.warn(e);
      }
      this.showLoading(false);
    },
    requestUpdateProfile() {
      this.$vs.dialog({
        color: "warning",
        type: "confirm",
        title: "Solicitar actualización de expediente",
        text: `¿Estás seguro de solicitar la actualización de expediente del proveedor ${this.supplier_id} | ${this.name}? Los documentos del expediente serán rechazados para su actualización.`,
        acceptText: "Solicitar actualización",
        cancelText: "Cancelar",
        accept: this.doRequestUpdateProfile,
      });
    },
    async doRequestUpdateProfile() {
      this.showLoading(true);
      try {
        const res = await axios.post(`/api/v1/supplier/profile/update/request/${this.supplier_id}`);
        if (res.data == "success") {
          this.saveSuccessNotif("Solicitud de expediente", "Se ha solicitado actualización del expediente correctamente.", 8000);
          this.traerDatos();
          this.reasons = "";
        }
      } catch (e) {
        this.warn(e);
      }
      this.showLoading(false);
    },
    getLegalProfileStatus(legalProfile) {
      if (legalProfile != null) {
        if (legalProfile.has_legal_claims == 1) {
          return "El Proveedor tiene coincidencias relevantes en material legal."
        } else {
          return "Perfil legal revisado."
        }
      } else {
        return "--";
      }
    },
    async saveLegalProfile() {
      try {
        this.showLoading(true);
        const res = await axios.post(`/api/supplier-onboarding/post/legal-profile`, {
          supplier_id: this.supplier_id,
          hasLegalIssues: this.legalProfileValue
        });
        this.showLPModal = false
        await this.traerDatos();
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (error) {
        this.showLoading(false);
        console.error(error);
        this.failedOperationNotif();
      }
    },
    async postSupplierProfileAsReviewed() {
      try {
        this.showLoading(true);
        await axios.post(`/api/supplier/post/${this.supplier_id}/profile-reviewed`);
        await this.traerDatos();
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (error) {
        this.showLoading(false);
        console.error(error);
        this.failedOperationNotif();
      }
    },
    // #endregion
    async getSupplierEventsList() {
      try {
        this.showLoading(true);
        const res = await axios.get(`/api/supplier/get/${this.supplier_id}/profile-events`);
        this.supplierEvents = [];
        res.data.forEach(event => {
          this.supplierEvents.push({
            color: "dark",
            icon: "BellIcon",
            title: this.logFrom(event),
            desc: event.description,
            time: (event.created_at)
          })
        });
        this.showLoading(false);
        this.saveSuccessNotif();
      } catch (error) {
        this.showLoading(false);
        console.error(error);
        this.failedOperationNotif();
      }
    },
    logFrom(event) {
      if (event.rg_user_id != null) {
        let r = "RedGirasol";
        if (this.isBackoffice) {
          r += ` (${event.rg_user_info.email})`;
        }
        return r;
      } else if (event.supplier_id != null) {
        return "Proveedor"
      } else if (event.client_id != null) {
        return "Solicitante"
      }
    },
  }
}
</script>

<style scoped>
.row {
  margin-top: 15px;
}

.card {
  padding: 0 10px;
}

.con-example-images {
  max-height: 250px;
  min-width: 130px;
  background-size: cover;
  position: relative;
  flex-flow: row;
  display: flex;
  justify-content: center;
}

.con-vs-dialog .vs-dialog {
  z-index: 90000 !important;
}

.con-vs-popup {
  z-index: 15864 !important;
}

.profile-data {
  text-align: center;
}

.border-rg {
  border-right: solid 1px #f2f2f2
}

.demo-alignment.custom>* {
  margin-right: 1rem;
}

.pill-desc {
  color: rgba(0, 0, 0, .7);
  text-align: center;
  font-size: 10px;
}

.events-list {
  max-height: 10rem;
  overflow: auto;
}
</style>
